import React from 'react';
import { mergeSx } from '../_internal/styleProps';

function Alert({ action, children, className = '', severity = 'info', style, sx, title, ...props }) {
  return (
    <div className={[
      'custom-alert',
      `custom-alert--${severity}`,
      className,
    ].filter(Boolean).join(' ')} role={severity === 'error' ? 'alert' : 'status'} style={mergeSx(sx, style)} {...props}>
      <div className="custom-alert__content">
        {title && <strong>{title}</strong>}
        <span>{children}</span>
      </div>
      {action && <div className="custom-alert__action">{action}</div>}
    </div>
  );
}

export default Alert;
